module.exports = __webpack_public_path__ + "static/media/header.8c277a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/portfolio/header.png
// module id = 114
// module chunks = 0